function windowWith() {
  return window.innerWidth !== undefined
    ? window.innerWidth
    : Math.max(document.documentElement.clientWidth, document.body.clientWidth);
}

const global = {
  window: window,
  document: document,
  navigator: navigator,
  screen: screen,
  windowWidth: windowWith(),
  domainUrlCadremploi: __DOMAIN_PREFIXES__.cadremploi,
  domainUrlServices: __DOMAIN_PREFIXES__.services,
  domainUrlAssets: __DOMAIN_PREFIXES__.assets
};

/**
 * Pour les tests unitaires
 */
function resetForTests() {
  global.window = window;
  global.document = document;
  global.navigator = navigator;
  global.screen = screen;
  global.windowWidth = windowWith();
  global.domainUrlCadremploi = __DOMAIN_PREFIXES__.cadremploi;
  global.domainUrlServices = __DOMAIN_PREFIXES__.services;
  global.domainUrlAssets = __DOMAIN_PREFIXES__.assets;

  return global;
}

global.resetForTests = resetForTests;

export default global;
